var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.usuario != null)?_c('toolbars'):_vm._e(),_c('v-main',{staticClass:"pb-5"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }